import { gql } from '@apollo/client'

const ALL_PROGRAM_FILTER_MAPS = gql`
  query ProgramFilterMapsQuery {
    programFilterMaps_LA {
      _id
      data {
        id
        filterId
        programId
      }
    }
  }
`

export { ALL_PROGRAM_FILTER_MAPS }
